/** A short buzz on touch phones that support it (Android); silently does nothing elsewhere or if the person asked for less motion. */
export function haptic(pattern: number | number[] = 12) {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    navigator.vibrate(pattern);
  } catch {
    // Vibration is a nicety, never an error.
  }
}
